<template>
  <button @click="onClick" class="ui basic compact icon button" style="box-shadow: none">
    <i v-if="isActive" class="caret down icon"></i>
    <i v-else class="caret right icon"></i>
  </button>
</template>

<script>
  import Vue from 'vue'
  export default {
    props: {
      active: {
        type: Boolean,
        default: false
      },
      onClickCallBack: {
        type: Function,
        default: null
      }
    },
    data() {
      return {
        isActive: this.active
      }
    },
    methods: {
      onClick() {
        this.isActive = !this.isActive;
        if (this.onClickCallBack) this.onClickCallBack(this.isActive);
      }
    }
  }
</script>

<style scoped>

</style>
